/* eslint-disable */
import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";

import { assetImages } from "constants";
import { joinEventHandler } from "helper/EventHelper/EventHelper";

import AgendaList from "Components/Agenda/AgendaList/AgendaList";
import PartnerList from "Components/Partners/PartnerList/PartnerList";
import CommunitySection from "Components/Community/CommunitySection/CommunitySection";
import UserList from "Components/Common/UserList/List/UserList";
import ShareModal from "Components/Common/Modals/ShareModal";
// import MyMeetingList from "Components/MyMeetings/MyMeetingList/MyMeetingList";

const EventDetailsBody = () => {
  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const fullURL = window.location.href;

  const [eventTitle, seteventTitle] = useState("");
  const [eventCategories, setEventCategories] = useState([]);
  const [eventMemberImages, seteventMemberImages] = useState([]);
  const [location, setlocation] = useState("");
  const [stateName, setstateName] = useState("");
  const [cityName, setcityName] = useState("");
  const [country, setcountry] = useState("");
  const [zipcode, setzipcode] = useState("");
  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [startTime, setstartTime] = useState("");
  const [endTime, setendTime] = useState("");
  const [eventSecret, setEventSecret] = useState("");

  const [isMember, setIsMember] = useState(false);
  const [isJoining, setIsJoining] = useState(false);

  const [copyMessage, setCopyMessage] = useState("");

  //function for get event details
  const getEventDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GUEST_EVENT_DETAILS_BY_ID + `/${params.id}`;

      console.log("url of event details------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response of event details------>", response);

      if (response.status) {
        if (userInfo) {
          const isMemberExist = response.data.eventmemberids.includes(
            userInfo?._id
          );

          setIsMember(isMemberExist);
        } else {
          setIsMember(false);
        }
        seteventTitle(response.data.title);
        setEventCategories(response.data.categories);
        seteventMemberImages(response.data.eventmemberimages);

        //assign zipcode
        setzipcode(response?.data?.zipcode);

        //assign city
        setcityName(response?.data?.city);

        //assign state
        setstateName(response?.data?.state);

        //assign country
        setcountry(response?.data?.country);

        //assign location
        setlocation(response?.data?.address);

        //assign start date
        setstartDate(response?.data?.fromdate);

        //assign start time
        setstartTime(response?.data?.starttime);

        //assign end date
        setendDate(response?.data?.todate);

        //assign end time
        setendTime(response?.data?.endtime);

        //secret
        setEventSecret(response?.data?.secret);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //join event function
  const joinEvent = async () => {
    setIsJoining(true);
    try {
      const response = await joinEventHandler(
        params.id,
        userInfo?.email,
        eventSecret,
        token
      );

      setIsJoining(false);
      if (response.status) {
        getEventDetails();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //share function
  const shareHandler = () => {
    if (token) {
      const redirectUrl = fullURL + `?refcode=${userInfo.referralcode}`;
      setCopyMessage(redirectUrl);
      const bootstrapModal = new bootstrap.Modal(
        document.getElementById("share_mdl")
      );
      bootstrapModal.show();
    }
  };

  useEffect(() => {
    if (params.id) {
      getEventDetails();
    }
  }, [params.id]);

  return (
    <>
      {/* banner section */}
      <div className="event_details_sec bg_white">
        <div className="container">
          <div className="details_top_row d-flex justify-content-between">
            <div className="left_details_info">
              <div className="d-flex align-items-center gap-1 mb-2">
                <i className="material-icons-outlined text-primary-gray fs-sm">
                  my_location
                </i>
                <span className="d-inline-block fs-sm text-primary-gray">
                  {location !== "" && `${location},`}
                  {cityName !== "" && `${cityName},`}{" "}
                  {stateName !== "" && `${stateName},`} {country}
                </span>
              </div>
              <h3 className="text-uppercase fs-xl text-primary d-flex align-items-center gap-2 mb-3">
                {eventTitle}
                <div className="exprt_share">
                  <ul className="list_style_none d-flex align-items-center justify-content-end gap-2 flex-wrap">
                    <li>
                      <Link
                        to="#"
                        // data-bs-toggle="modal"
                        // data-bs-target="#share_mdl"
                        className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden bg_gray"
                        onClick={shareHandler}
                      >
                        <i className="material-icons-outlined fs-lg text-primary-gray">
                          share
                        </i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </h3>

              <ul className="list_style_none d-flex align-items-center gap-2 mb-3 details_list">
                {eventCategories.map((item, index) => {
                  return (
                    <li
                      className="text-primary fs-sm fw-medium position-relative"
                      key={index}
                    >
                      {item.label}
                    </li>
                  );
                })}
              </ul>
              <div className="agenda_user_outer d-flex align-items-center gap-3 flex-wrap">
                <div className="register_btn">
                  {token ? (
                    isMember ? (
                      <Link
                        to="#"
                        className="btn outline h-auto px-3 py-2 text-nowrap d-flex align-items-center gap-2"
                        // data-bs-toggle="modal"
                        // data-bs-target="#register_info_modal"
                      >
                        <span className="d-block material-icons-outlined fs-md text-success">
                          check_circle
                        </span>
                        <span className="d-block">Already Joined</span>
                      </Link>
                    ) : (
                      <button
                        disabled={isJoining ? true : false}
                        style={{
                          cursor: isJoining ? "not-allowed" : "pointer",
                        }}
                        className="btn primary-btn"
                        onClick={joinEvent}
                      >
                        Join
                        {isJoining && (
                          <div
                            className="mx-2 spinner-border spinner-border-sm"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        )}
                      </button>
                    )
                  ) : (
                    <Link
                      to="#"
                      className="btn primary-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#login_modal"
                    >
                      Join
                    </Link>
                  )}
                </div>

                <div className="agenda_info_users">
                  <ul className="d-flex align-items-center list_style_none">
                    {eventMemberImages.map((member, index) => {
                      return (
                        <li
                          className="rounded-circle overflow-hidden"
                          key={index}
                        >
                          <img
                            src={
                              member.userimage == ""
                                ? assetImages.defaultUser
                                : url.SERVER_URL + member.userimage
                            }
                            alt=""
                          />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            <div className="right_details_info">
              <h3 className="d-flex align-items-center gap-2 mb-3">
                <i className="material-icons-outlined text-pink">schedule</i>
                <span className="fs-xl fw-bold text-primary">{startTime}</span>
              </h3>
              <h3 className="d-flex align-items-center gap-2">
                <i className="material-icons-outlined text-pink">schedule</i>
                <span className="fs-xl fw-bold text-primary">{endTime}</span>
              </h3>
            </div>
          </div>
          <div className="details_bttm_tabs">
            <div className="tab_links">
              <ul className="nav nav-tabs mb-0">
                <li className="nav-item">
                  <button
                    className="nav-link active text-primary text-uppercase fw-semibold fs-sm"
                    data-bs-toggle="tab"
                    data-bs-target="#agenda"
                  >
                    Agenda
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className="nav-link text-primary text-uppercase fw-semibold fs-sm"
                    data-bs-toggle="tab"
                    data-bs-target="#speaker"
                  >
                    Speakers
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className="nav-link text-primary text-uppercase fw-semibold fs-sm"
                    data-bs-toggle="tab"
                    data-bs-target="#partners"
                  >
                    Partners
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className="nav-link text-primary text-uppercase fw-semibold fs-sm"
                    data-bs-toggle="tab"
                    data-bs-target="#foro"
                  >
                    Community
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className="nav-link text-primary text-uppercase fw-semibold fs-sm"
                    data-bs-toggle="tab"
                    data-bs-target="#network"
                  >
                    Network
                  </button>
                </li>
                {/* <li className="nav-item">
                  <button
                    className="nav-link text-primary text-uppercase fw-semibold fs-sm"
                    data-bs-toggle="tab"
                    data-bs-target="#my_meeting"
                  >
                    My meetings
                  </button>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* bottom section */}
      <section className="event_sec">
        <div className="container">
          <div className="tab-content">
            <div className="tab-pane fade show active" id="agenda">
              <AgendaList showTitle={false} eventId={params.id} />
            </div>
            <div className="tab-pane fade" id="speaker">
              <UserList eventId={params.id} componentName={"speakers"} />
            </div>
            <div className="tab-pane fade" id="partners">
              <PartnerList eventId={params.id} />
            </div>
            <div className="tab-pane fade" id="foro">
              <CommunitySection eventId={params.id} />
            </div>
            <div className="tab-pane fade" id="network">
              <UserList eventId={params.id} componentName={"networks"} />
            </div>
            <div className="tab-pane fade" id="my_meeting">
              {/* <div className="meet_bx_outer">
                <div className="meet_row bg_white p-4 d-flex mb-3">
                  <div className="meet_time_left">
                    <h3 className="d-flex align-items-center gap-2 mb-2">
                      <i className="material-icons-outlined text-pink fs-md">
                        schedule
                      </i>
                      <span className="fs-lg fw-bold text-primary">
                        10:00 - 10:30
                      </span>
                    </h3>
                    <h5 className="d-flex align-items-center gap-2">
                      <i className="material-icons-outlined fs-md text-primary-gray">
                        event_note
                      </i>
                      <span className="text-primary-gray fs-sm">
                        15/25/2023
                      </span>
                    </h5>
                  </div>
                  <div className="meet_time_right">
                    <h3 className="text-uppercase fs-xl text-primary d-flex align-items-center gap-2 mb-3">
                      Jhon Morkel
                      <span className="d-inline-block rounded-90 fs-sm text-pink fw-medium">
                        Client
                      </span>
                    </h3>
                    <p>
                      I am just going to go with it. I read on some website that
                      the 1600 and 2600 was better, but, they are both worse
                      than the 9600k. And, anyways I already have a B365 LGA
                      1151 Gen 2 motherboard, so, it's the most logical upgrade.
                    </p>
                    <div className="meet_btns d-flex align-items-center gap-2 mt-3">
                      <Link to="#" className="btn primary-btn">
                        Accept
                      </Link>
                      <Link to="#" className="btn">
                        Reject
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="meet_row bg_white p-4 d-flex mb-3">
                  <div className="meet_time_left">
                    <h3 className="d-flex align-items-center gap-2 mb-2">
                      <i className="material-icons-outlined text-pink fs-md">
                        schedule
                      </i>
                      <span className="fs-lg fw-bold text-primary">
                        07:00 - 09:00
                      </span>
                    </h3>
                    <h5 className="d-flex align-items-center gap-2">
                      <i className="material-icons-outlined fs-md text-primary-gray">
                        event_note
                      </i>
                      <span className="text-primary-gray fs-sm">
                        15/25/2023
                      </span>
                    </h5>
                  </div>
                  <div className="meet_time_right">
                    <h3 className="text-uppercase fs-xl text-primary d-flex align-items-center gap-2 mb-3">
                      Manni Disusa
                      <span className="d-inline-block rounded-90 fs-sm text-pink fw-medium">
                        Supplier
                      </span>
                    </h3>
                    <p>
                      I am just going to go with it. I read on some website that
                      the 1600 and 2600 was better, but, they are both worse
                      than the 9600k. And, anyways I already have a B365 LGA
                      1151 Gen 2 motherboard, so, it's the most logical upgrade.
                    </p>
                    <div className="meet_btns d-flex align-items-center gap-2 mt-3">
                      <Link to="#" className="btn primary-gray-btn">
                        Pending
                      </Link>
                      <Link to="#" className="btn outline">
                        Cancel Request
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="meet_row bg_white p-4 d-flex mb-3">
                  <div className="meet_time_left">
                    <h3 className="d-flex align-items-center gap-2 mb-2">
                      <i className="material-icons-outlined text-pink fs-md">
                        schedule
                      </i>
                      <span className="fs-lg fw-bold text-primary">
                        10:00 - 10:30
                      </span>
                    </h3>
                    <h5 className="d-flex align-items-center gap-2">
                      <i className="material-icons-outlined fs-md text-primary-gray">
                        event_note
                      </i>
                      <span className="text-primary-gray fs-sm">
                        15/25/2023
                      </span>
                    </h5>
                  </div>
                  <div className="meet_time_right">
                    <h3 className="text-uppercase fs-xl text-primary d-flex align-items-center gap-2 mb-3">
                      Jhon Morkel
                      <span className="d-inline-block rounded-90 fs-sm text-pink fw-medium">
                        Client
                      </span>
                    </h3>
                    <p>
                      I am just going to go with it. I read on some website that
                      the 1600 and 2600 was better, but, they are both worse
                      than the 9600k. And, anyways I already have a B365 LGA
                      1151 Gen 2 motherboard, so, it's the most logical upgrade.
                    </p>
                    <div className="meet_btns d-flex align-items-center gap-2 mt-3">
                      <Link to="#" className="btn primary-btn">
                        Accept
                      </Link>
                      <Link to="#" className="btn">
                        Reject
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="meet_row bg_white p-4 d-flex mb-3">
                  <div className="meet_time_left">
                    <h3 className="d-flex align-items-center gap-2 mb-2">
                      <i className="material-icons-outlined text-pink fs-md">
                        schedule
                      </i>
                      <span className="fs-lg fw-bold text-primary">
                        10:00 - 10:30
                      </span>
                    </h3>
                    <h5 className="d-flex align-items-center gap-2">
                      <i className="material-icons-outlined fs-md text-primary-gray">
                        event_note
                      </i>
                      <span className="text-primary-gray fs-sm">
                        15/25/2023
                      </span>
                    </h5>
                  </div>
                  <div className="meet_time_right">
                    <h3 className="text-uppercase fs-xl text-primary d-flex align-items-center gap-2 mb-3">
                      BILL Watson
                      <span className="d-inline-block rounded-90 fs-sm text-pink fw-medium">
                        Client
                      </span>
                    </h3>
                    <p>
                      I am just going to go with it. I read on some website that
                      the 1600 and 2600 was better, but, they are both worse
                      than the 9600k. And, anyways I already have a B365 LGA
                      1151 Gen 2 motherboard, so, it's the most logical upgrade.
                    </p>
                    <div className="meet_btns d-flex align-items-center gap-2 mt-3">
                      <Link to="#" className="btn disabled">
                        Accepted
                      </Link>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#feedback_modal"
                        className="btn outline"
                      >
                        Feedback
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="meet_row bg_white p-4 d-flex mb-3">
                  <div className="meet_time_left">
                    <h3 className="d-flex align-items-center gap-2 mb-2">
                      <i className="material-icons-outlined text-pink fs-md">
                        schedule
                      </i>
                      <span className="fs-lg fw-bold text-primary">
                        10:00 - 10:30
                      </span>
                    </h3>
                    <h5 className="d-flex align-items-center gap-2">
                      <i className="material-icons-outlined fs-md text-primary-gray">
                        event_note
                      </i>
                      <span className="text-primary-gray fs-sm">
                        15/25/2023
                      </span>
                    </h5>
                  </div>
                  <div className="meet_time_right">
                    <h3 className="text-uppercase fs-xl text-primary d-flex align-items-center gap-2 mb-3">
                      BILL Watson
                      <span className="d-inline-block rounded-90 fs-sm text-pink fw-medium">
                        Speakers
                      </span>
                    </h3>
                    <p>
                      I am just going to go with it. I read on some website that
                      the 1600 and 2600 was better, but, they are both worse
                      than the 9600k. And, anyways I already have a B365 LGA
                      1151 Gen 2 motherboard, so, it's the most logical upgrade.
                    </p>
                    <div className="meet_btns d-flex align-items-center gap-2 mt-3">
                      <Link to="#" className="btn disabled">
                        Accepted
                      </Link>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#feedback_modal"
                        className="btn outline"
                      >
                        Feedback
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="meet_row bg_white p-4 d-flex mb-3">
                  <div className="meet_time_left">
                    <h3 className="d-flex align-items-center gap-2 mb-2">
                      <i className="material-icons-outlined text-pink fs-md">
                        schedule
                      </i>
                      <span className="fs-lg fw-bold text-primary">
                        07:00 - 09:00
                      </span>
                    </h3>
                    <h5 className="d-flex align-items-center gap-2">
                      <i className="material-icons-outlined fs-md text-primary-gray">
                        event_note
                      </i>
                      <span className="text-primary-gray fs-sm">
                        15/25/2023
                      </span>
                    </h5>
                  </div>
                  <div className="meet_time_right">
                    <h3 className="text-uppercase fs-xl text-primary d-flex align-items-center gap-2 mb-3">
                      Manni Disusa
                      <span className="d-inline-block rounded-90 fs-sm text-pink fw-medium">
                        Supplier
                      </span>
                    </h3>
                    <p>
                      I am just going to go with it. I read on some website that
                      the 1600 and 2600 was better, but, they are both worse
                      than the 9600k. And, anyways I already have a B365 LGA
                      1151 Gen 2 motherboard, so, it's the most logical upgrade.
                    </p>
                    <div className="meet_btns d-flex align-items-center gap-2 mt-3">
                      <Link to="#" className="btn primary-gray-btn">
                        Pending
                      </Link>
                      <Link to="#" className="btn outline">
                        Cancel Request
                      </Link>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* <MyMeetingList eventId={params.id} /> */}
            </div>
          </div>
        </div>
      </section>

      <ShareModal copyMessage={copyMessage} />
    </>
  );
};

export default EventDetailsBody;
